import React from 'react';
import { Tooltip, IconButton, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

interface Props {
  buildingLabel: string;
  timeLabel: string;
}

export const RatingSummaryTooltip = ({ buildingLabel, timeLabel }: Props) => {
  return (
    <Tooltip
      placement="left"
      arrow
      title={
        <>
          <Typography fontWeight={600} fontSize={12} mb={0.5}>
            How this is calculated
          </Typography>

          <Typography fontSize={12} lineHeight={1.5}>
            Arithmetic mean of all star ratings (1–5) from feedback submissions for <strong>{buildingLabel}</strong>{' '}
            within the <strong>{timeLabel}</strong> time range.
          </Typography>
        </>
      }
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 260,
            p: 1.5,
            backgroundColor: '#fff',
            color: 'text.secondary',
            boxShadow: '0px 0px 4px rgb(0 0 0 / 12%)',
          },
        },
        arrow: {
          sx: {
            color: 'rgb(0 0 0 / 12%)',
          },
        },
      }}
    >
      <IconButton
        size="small"
        sx={{
          color: 'text.secondary',
          opacity: 0.6,
          transition: '0.15s',
          '&:hover': {
            color: 'text.primary',
            opacity: 1,
          },
        }}
      >
        <InfoIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
};
